import React from "react";
import "./ConfirmationModal.css";
import { Modal } from "react-bootstrap";
import { CrossIconBtn } from "assets/SVGs/SVGs";
import CustomButton from "components/widgets/custom-button/CustomButton";

const ConfirmationModal = ({
  show,
  setShow,
  onClose,
  svgIcon,
  title,
  description,
  btnText,
  onClick,
  isNotClosable,
}) => {
  const handleClose = () => {
    if (!isNotClosable) {
      if (onClose) {
        onClose();
      } else {
        setShow(false);
      }
    }
  };

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="cm_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="cm_body">
        {!isNotClosable ? (
          <div className="cm_close_icon_container">
            <CrossIconBtn
              className="cm_cross_icon"
              onClick={() => (onClose ? onClose() : setShow(!show))}
            />
          </div>
        ) : null}
        <div className="cm_content_container">
          <div className="cm_svg_container">{svgIcon}</div>
          <p className="cm_title_text">{title}</p>
          {description ? <p className="cm_description_text">{description}</p> : null}
          {btnText ? (
            <CustomButton
              text={btnText}
              width={"100%"}
              className={"cm_confirm_btn"}
              onClick={() => {
                onClick();
              }}
            />
          ) : null}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
